// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-tooltip > .v-overlay__content {
  background: rgb(var(--v-theme-surface-variant));
  color: rgb(var(--v-theme-on-surface-variant));
  border-radius: 4px;
  font-size: 0.875rem;
  line-height: 1.6;
  display: inline-block;
  padding: 5px 16px;
  text-transform: initial;
  width: auto;
  opacity: 1;
  transition-property: opacity, transform;
  overflow-wrap: break-word;
}
:where(.vuetify-styles) .v-tooltip > .v-overlay__content[class*=enter-active] {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 150ms;
}
:where(.vuetify-styles) .v-tooltip > .v-overlay__content[class*=leave-active] {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  transition-duration: 75ms;
}
:where(.vuetify-styles) .v-tooltip:not(.v-tooltip--interactive) > .v-overlay__content {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VTooltip/VTooltip.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,6CAA6C;EAC7C,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,sDAAsD;EACtD,0BAA0B;AAC5B;AACA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB","sourcesContent":[".v-tooltip > .v-overlay__content {\n  background: rgb(var(--v-theme-surface-variant));\n  color: rgb(var(--v-theme-on-surface-variant));\n  border-radius: 4px;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  display: inline-block;\n  padding: 5px 16px;\n  text-transform: initial;\n  width: auto;\n  opacity: 1;\n  transition-property: opacity, transform;\n  overflow-wrap: break-word;\n}\n.v-tooltip > .v-overlay__content[class*=enter-active] {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n.v-tooltip > .v-overlay__content[class*=leave-active] {\n  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  transition-duration: 75ms;\n}\n.v-tooltip:not(.v-tooltip--interactive) > .v-overlay__content {\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
